// import React from 'react'

// const Result = ({t1,t2,t3}) => {
//   return (
//     <div className="h-9 w-full border-2 border-blue-300 border-solid rounded-xl mt-4 flex pl-4 pr-2 items-center">
//             <div className="text-sm font-bold font-poppins pb-[15px] flex justify-start">{t1}</div>
//             <div className="text-sm font-bold font-poppins pb-[15px] flex justify-center">{t2}</div>
//             <div className="relative flex justify-end">
//               <div className="text-sm font-bold w-44 rounded-lg h-5 bg-gradient-to-r from-blue-300 via-orange-200 to-[var(--red-color)]"></div>
//               <div
//                 className="absolute -top-1 left-0 transform w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent rounded-full border-t-purple-800"
//                 style={{ left: t3 }}
//               ></div>
//             </div>
//           </div>
//   )
// }

// export default Result

import React from 'react'

const Result = ({ t1, t2, t3}) => {
  t3 = typeof t3 === 'string' ? t3.toLowerCase() : '';
  const value = t3 === "not detected" ? 60 : t3 === "detected" ? 135 : 205
  return (
    <div className="h-10 w-full pr-3 pl-4 border-[3px] border-blue-300 border-solid rounded-xl mt-4 flex items-center">
      <div className="text-sm font-bold font-poppins pb-[12px] flex-1 flex justify-start">{t1}</div>
      <div className={`text-sm font-bold font-poppins pb-[12px] flex-1 flex justify-center ${t2.toLowerCase().includes('not') ? 'text-black' : 'text-[var(--red-color)]'}`}>
        {t2}
      </div>
      <div className="relative flex-1 flex justify-end">
        <div className="text-sm font-bold w-44 rounded-lg h-5 bg-gradient-to-r from-blue-300 via-orange-200 to-[var(--red-color)]"></div>
        <div
          className="absolute -top-1 left-0 transform w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent rounded-full border-t-purple-800"
          style={{ left: value }}
        ></div>
      </div>
    </div>
  )
}

export default Result


export const Result01 = ({ t1, t2, t3}) => {
  t3 = typeof t3 === 'string' ? t3.toLowerCase() : '';
  const value = t3 === "not detected" ? 60 : t3 === "detected" ? 135 : 205
  return (
    <div className="h-10 w-full pr-3 pl-4 border-[3px] border-blue-300 border-solid rounded-xl mt-4 flex items-center">
      <div className="text-sm font-bold font-poppins flex-1 flex justify-start">{t1}</div>
      <div className={`text-sm font-bold font-poppins flex-1 flex justify-center ${t2.toLowerCase().includes('not') ? 'text-black' : 'text-[var(--red-color)]'}`}>
        {t2}
      </div>
      <div className="relative flex-1 flex justify-end">
        <div className="text-sm font-bold w-44 rounded-lg h-5 bg-gradient-to-r from-blue-300 via-orange-200 to-[var(--red-color)]"></div>
        <div
          className="absolute -top-1 left-0 transform w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent rounded-full border-t-purple-800"
          style={{ left: value }}
        ></div>
      </div>
    </div>
  )
}

